/**
 * Runtime flag key for GP Membership booking availability.
 *
 * The value is read from Cloudflare R2 by the server and returned through the
 * same-origin `/api/feature-flags` proxy. Server authorization further limits
 * the shared staging flag to the trusted Development pod; Production remains
 * disabled regardless of the R2 value.
 */
export const GP_MEMBERSHIP_BOOKING_FLAG_KEY = 'booking.gp-membership';
